export enum DeviceComponentType {
  Pulleys = 'pulleys',
  Car = 'car',
  Landings = 'landings',
  Controller = 'controller',
  Machinery = 'machinery',
  ShaftPit = 'shaft_pit',
  Shaft = 'shaft',
  TopOfCar = 'top_of_car',
  Parachute = 'parachute',
  TractionCable = 'tractionCable',
  Doors = 'doors',
  Brake = 'brake',
  Combplate = 'combplate',
  Handrail = 'handrail',
  Incline = 'incline',
  UpperLanding = 'upperLanding',
  LowerLanding = 'lowerLanding',
  SafetyContacts = 'safety_contacts',
  Lightning = 'lighting',
  Steps = 'steps',
  Drive = 'drive',
  MotorRoom = 'motorRoom',
  Multiple = 'multiple',
  Other = 'other',
  None = 'none',
}
